import styled from 'styled-components';

const Container = styled.div`
    padding: 0.2rem;
    border-color: rgba(200, 200, 200, 0.6);
    background: rgba(255, 255, 255, 0.2);

    @media (max-width: 1024px) {
        border-color: rgba(200, 200, 200, 0.42);
    }

    body.dark & {
        background: rgba(0, 0, 0, 0.64);
    }
`

const InfosIcon = ({...props}) => {

    return (
        <Container className="border rounded-full" {...props}>
            <svg className="size-7 2xl:size-8 text-white cursor-pointer" id={`privatized_space`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
                <rect width="256" height="256" fill="none"/>
                <circle cx="128" cy="128" r="96" fill="#7CFECB" fillOpacity="0.42" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
                <path d="M120,120a8,8,0,0,1,8,8v40a8,8,0,0,0,8,8" fill="none" stroke="currentColor"
                      strokeLinecap="round" strokeLinejoin="round" strokeWidth="16"/>
                <circle fill="currentColor" cx="124" cy="84" r="12"/>
            </svg>
        </Container>
    )
}

export default InfosIcon;
